import { createThemes } from "@tamagui/theme-builder";
import { themes } from "./generated-v5";
import { v5Templates } from "./v5-templates";
export * from "./v5-themes";
import { tokens } from "./v5-tokens";
export {
  createThemes,
  themes,
  tokens,
  v5Templates
};
//# sourceMappingURL=v5.js.map
